import {ActionTree} from 'vuex'
import axios from "axios";
import DataVariableInterface from "../../DataVariables/ts/DataVariableInterface";

export const actions: ActionTree<any, any> = {

    /**
     * Reset importer state
     *
     * @param state
     * @param getters
     * @param commit
     * @param dispatch
     */
    resetState: ({state, getters, commit, dispatch}) => {

        commit('setFileInspectorDone', false);
        commit('setColumnMapperDone', false);
        commit('setUploaderDone', false);
        commit('clearMappings');
        commit('setStepperModel', 1);
        commit('resetComponents');
    },

    /**
     * Generate test import file
     *
     * @param state
     * @param getters
     * @param commit
     * @param dispatch
     * @param dataVariables
     */
    requestTestFile: ({state, getters, commit, dispatch}, dataVariables) => {

        const ids = dataVariables.map((d: DataVariableInterface) => {
            return {id: d.id};
        });

        return new Promise((resolve, reject) => {

            axios.post('/import-file', {dataVariables: ids})

                .then(() => {

                    resolve(null);
                })
                .catch(error => {

                    reject(error);
                });
        });
    },
};
